import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { Constants, Environment } from '@shared/utils/constants';
import { getLocalStorageItem } from '@shared/utils/browserStorageUtils';
import { useMsClarityIdentify, useMsClarityTracking } from '@shared/hooks';
// Learn more about clarity API here: https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-api
export const IClarityFunctionNames = {
    IDENTIFY: 'identify',
    SET: 'set',
    CONSENT: 'consent',
    UPGRADE: 'upgrade'
};
export const MsClarityEnabledEnvironments = [
    Environment.Canary,
    Environment.Production,
    Environment.Development
];
export const MsClarity = ({ allowTracking })=>{
    const { correlationId } = useSelector((state)=>state.config);
    const spzaId = getLocalStorageItem(Constants.LocalStorage.spzaUserId);
    useMsClarityTracking({
        allowTracking
    });
    useMsClarityIdentify({
        spzaId,
        correlationId
    });
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
